import React, { ReactNode } from 'react';
import styles from './styles/SettingEntry.module.css';

type SettingEntryProps = {
	label: ReactNode;
	children?: ReactNode;
};

const SettingEntry = ({ label, children }: SettingEntryProps) => (
	<div className={styles.setting}>
		<b>{label}</b>
		<div>{children}</div>
	</div>
);

export default SettingEntry;
